import { QuestionsPostRequest } from './post'

export class QuestionsPutRequest extends QuestionsPostRequest {
  questionId!: string
  version!: number
}
